import { render, staticRenderFns } from "./ReferenceGeneratorModal.vue?vue&type=template&id=67a4f747&"
import script from "./ReferenceGeneratorModal.vue?vue&type=script&lang=ts&"
export * from "./ReferenceGeneratorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports